module.exports = __webpack_public_path__ + "static/media/currency-hide.2c51f37e.png";